module.exports = __webpack_public_path__ + "static/8ad1d8ac7596f00c6fbf368c3f3ee39c2fcb0f2bfd52d198734cda1f5c9f93df-76233f998dff908095c68c7c19e22388.jpeg";